import { useState, useEffect } from 'react';
import { Cloud, CloudOff, Loader2 } from 'lucide-react';
import { getSyncQueue } from '../lib/offlineStore';

export function SyncIndicator() {
  const [online, setOnline] = useState(navigator.onLine);
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    const onOnline = () => setOnline(true);
    const onOffline = () => setOnline(false);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);

    const checkQueue = async () => {
      try {
        const queue = await getSyncQueue();
        setPendingCount(queue.length);
      } catch {}
    };
    checkQueue();
    const interval = setInterval(checkQueue, 5000);

    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
      clearInterval(interval);
    };
  }, []);

  if (!online) {
    return (
      <div className="flex items-center gap-1.5 text-amber-400 text-xs">
        <CloudOff className="w-3.5 h-3.5" />
        <span>Offline</span>
      </div>
    );
  }

  if (pendingCount > 0) {
    return (
      <div className="flex items-center gap-1.5 text-primary-400 text-xs">
        <Loader2 className="w-3.5 h-3.5 animate-spin" />
        <span>Syncing</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5 text-green-400 text-xs">
      <Cloud className="w-3.5 h-3.5" />
      <span>Synced</span>
    </div>
  );
}
